// allow boolean/nullable type to allow syntax like
// cx(styles.button, props.isDisabled && styles.disabled)
type MaybeClassName = (string | boolean) | null | undefined;

export default function cx(...classes: MaybeClassName[]): string {
  return classes.filter((validClass) => validClass).join(' ');
}
